export const PROFILE_ME = "PROFILE_ME";
export const PROFILE_CHANGE_PASSWORD = "PROFILE_CHANGE_PASSWORD";
